import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  selectViewport,
  setViewport,
  VIEWPORT_XS,
  VIEWPORT_SM,
  VIEWPORT_MD,
  VIEWPORT_LG,
  VIEWPORT_XL,
} from '../../store';

class Viewport extends Component {
  static propTypes = {
    viewport: PropTypes.oneOf([
      VIEWPORT_XS,
      VIEWPORT_SM,
      VIEWPORT_MD,
      VIEWPORT_LG,
      VIEWPORT_XL,
    ]),
    setViewport: PropTypes.func,
    matchMedia: PropTypes.func,
    children: PropTypes.node,
  };

  static defaultProps = {
    setViewport() {},
    matchMedia: (...args) => window.matchMedia(...args),
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateViewport, true);
    this.updateViewport();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateViewport, true);
  }

  updateViewport = () => {
    let viewport = VIEWPORT_XS;

    [VIEWPORT_SM, VIEWPORT_MD, VIEWPORT_LG, VIEWPORT_XL].forEach(val => {
      if (this.props.matchMedia(`(min-width: ${val}px)`).matches) {
        viewport = val;
      }
    });

    if (viewport !== this.props.viewport) {
      this.props.setViewport(viewport);
    }
  };

  render() {
    return this.props.viewport ? this.props.children : null;
  }
}

const mapStateToProps = () =>
  createStructuredSelector({
    viewport: selectViewport,
  });

/* eslint-disable-next-line import/no-default-export */
export default connect(
  mapStateToProps,
  { setViewport },
  null,
  { pure: false },
)(Viewport);
